import { ExportButton } from "@/components/commons/export-button"
import { ENDPOINTS } from "@/constants"
import { useDefaulterSearchParams, useDownloadCSV } from "@/hooks"
interface DefaultersDownloadProps {
  mode: "order" | "subscription"
}
export const DefaultersDownload = ({ mode }: DefaultersDownloadProps) => {
  const { params } = useDefaulterSearchParams()
  const endpoint = ENDPOINTS.DEFAULTER_SUBSCRIPTION_DOWNLOAD
  const modeName = mode === "order" ? "rotativo" : "recorrente"
  const fileName = `${modeName}_${new Date().getTime()}.csv`
  const newParams = {
    page: 0,
    quantity: 1000,
    startDateTime: params.startDateTime,
    endDateTime: params.endDateTime,
    queryType: params.queryType,
  }
  const { handleDownload, isDownloading } = useDownloadCSV({
    endpoint,
    fileName,
    params: newParams as DownloadCSVParamsType,
  })
  return <ExportButton onClick={handleDownload} disabled={isDownloading} />
}
